@if (contactsTotal()) {
  <div class="contacts-top">
    <div class="contacts-count">
      You have <span> {{ contactsTotal() }} </span> contacts
    </div>
    <div class="actions">
      <div class="search-box">
      <span class="search-icon">
        <app-icon size="small" color="#9BB2DD" name="search"></app-icon>
      </span>
        <input [formControl]="searchContact" type="text" placeholder="Search"/>
      </div>
    </div>
  </div>

  <div #scrollContactsContainer class="grid-container" (scroll)="onContactsScroll()">
    @for (contact of contactsList(); track contact.id) {
      <app-contact-card (eventTriggered)="onEvent($event)" [contact]="contact"></app-contact-card>
    }
  </div>
}
@else {
  <div class="empty-screen">
    <div class="header">
      No contacts yet
    </div>
    <div class="sub-header">
      You can add your contacts to this list using mobile app.
    </div>
  </div>
}


